import { render, staticRenderFns } from "./NewRealEstateCostModal.vue?vue&type=template&id=703a435c&scoped=true&"
import script from "./NewRealEstateCostModal.vue?vue&type=script&lang=js&"
export * from "./NewRealEstateCostModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703a435c",
  null
  
)

export default component.exports